export class ConfigDB {
	static data = {
		settings: {
			layout_type: 'ltr',
			layout_mode:'',
			sidebar: {
				type: 'compact-wrapper',
			},
			sidebar_setting: 'default-sidebar',
		},
		color: {
			primary_color: '#5c61f1',
			secondary_color: '#eeb830',
			mix_background_layout: 'light-only',
		},
	}
}
export default ConfigDB;




